module.exports = __webpack_public_path__ + "static/img/davis_pictgrid24_920x895.0efe3c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid24_920x895.jpg
// module id = qzXG
// module chunks = 0